import BrandsRoutes from './Brands/routes';
import VendorCatalogsRoutes from './VendorCatalogs/routes';
import VendorReturnsRoutes from './VendorReturns/routes';
import SuppliersRoutes from './SuppliersIframe/routes';
import BulkImportRoutes from './BulkImport/routes';

export default [
  ...BrandsRoutes,
  ...VendorCatalogsRoutes,
  ...VendorReturnsRoutes,
  ...SuppliersRoutes,
  ...BulkImportRoutes,
];
